import { MappedClass, MappedProperty, MappedPropertyArray, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterError } from './z-printer-error';
import { ZPrinterTransaction } from './z-printer-transaction';
import { ZPrinterTransactionStatus } from './z-printer-transaction-status';
import { ZPrinterWarning } from './z-printer-warning';
import { PrintJobDto } from '@h5s/dtos-api';

export type PrintJobDtoEntity = PrintJobDto;

@MappedClass()
export class ZPrinterPrintJob {
  @MappedProperty()
  closure?: number | null;

  @MappedProperty()
  date?: string;

  @MappedProperty()
  email?: string | null;

  @MappedPropertyArray(() => ZPrinterError)
  errors?: Array<ZPrinterError> | null;

  @MappedPropertyArray(() => ZPrinterWarning)
  warnings?: Array<ZPrinterWarning> | null;

  @MappedProperty()
  number?: number | null;

  @MappedProperty({
    fromDto: 'print_job_id',
    toDto: 'print_job_id',
  })
  printJobId?: string | null;

  @MappedProperty()
  retries?: number;

  @MappedProperty()
  rounding?: number | null;

  @MappedProperty()
  status?: ZPrinterTransactionStatus;

  @MappedPropertyClass(() => ZPrinterTransaction)
  transaction?: ZPrinterTransaction | null;
}
